<!-- client/src/components/Navigation/MainNavbar.vue -->
<template>
  <!--<v-app-bar app color="primary" scroll-behavior="fade-image" image="/navbar-bg.png">-->
  <v-app-bar app color="primary" scroll-behavior="elevate">
    <v-btn v-if="authStore.user" icon @click="sidebarStore.toggleSidebar()">
      <v-icon>mdi-menu</v-icon>
    </v-btn>
    
    <v-app-bar-title>
      <router-link to="/" style="color: inherit; text-decoration: none">
        <img src="/logo.png" alt="Reeflendar Logo" style="height:64px;vertical-align:middle;" />
      </router-link>
    </v-app-bar-title>

    <template v-if="authStore.user">
      <span class="username">
        {{ authStore.user.email }}
        <span v-if="authStore.user.role === 'admin'">(admin)</span>
        <img :src="authStore.user.image_url" alt="User Image" class="user-image" referrerpolicy="no-referrer" />
      </span>
      <v-btn @click="authStore.logout()" variant="flat" color="secondary">
        Logout
      </v-btn>
    </template>

    <template v-else>
      <v-btn @click="authStore.login()" variant="flat" color="red">
        Login/Register
      </v-btn>
    </template>

    <!-- Error Notification -->
    <v-snackbar
      v-model="popupStore.showMessage"
      :color="popupStore.messageType"
      timeout="5000"
      top
      location="top"
    >
      <b>{{ errorTitle }}</b><br/>
      <span v-html="errorMessage"></span>
      <template v-slot:actions>
        <v-btn color="white" text @click="popupStore.clearMessage()">Close</v-btn>
      </template>
    </v-snackbar>
  </v-app-bar>
</template>

<script>
import { useAuthStore} from '@/store'
import { useModalStore } from '@/store';
import { useSidebarStore } from '@/store'
import { usePopupStore } from '@/store'
import { watch, computed } from 'vue';

export default {
  name: 'MainNavbar',
  setup() {
    const authStore = useAuthStore();
    const sidebarStore = useSidebarStore();
    const modalStore = useModalStore();

    const popupStore = usePopupStore();
    const errorTitle = computed(() => popupStore.messageTitle);
    const errorMessage = computed(() => popupStore.messageText);

    watch(
      () => popupStore.messageText,
      (newErrorMessage) => {
        if (newErrorMessage) {
          popupStore.showMessage = true;
        } else {
          popupStore.showMessage = false;
        }
      },
      { immediate: true }
    );

    return {
      authStore,
      modalStore,
      sidebarStore,
      popupStore,
      errorTitle,
      errorMessage,
    };
  }
};
</script>

<style scoped>
.username {
  margin-right: 10px;
  display: flex;
  align-items: center;
}

@media (max-width: 600px) {
  .username {
    display: none;
  }
}

.user-image {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-right: 10px;
}

</style>